import React from "react";
import { Outlet } from "react-router-dom";

const MapLayout = () => {
  // Just render child routes, no Map here
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Outlet />
    </div>
  );
};

export default MapLayout;
